import { render, staticRenderFns } from "./ConfirmStock.vue?vue&type=template&id=70d9b7f9"
import script from "./ConfirmStock.vue?vue&type=script&lang=js"
export * from "./ConfirmStock.vue?vue&type=script&lang=js"
import style0 from "./ConfirmStock.vue?vue&type=style&index=0&id=70d9b7f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports